import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { LinkDirective } from '../../_shared/directives/link.directive';
import { ButtonGroupAlignment, IButtonGroup } from '../../_shared/models/button/button-group.model';
import { IButton } from '../../_shared/models/button/button.model';
import { IDynamicElement } from '../../_shared/models/dynamic/dynamic-element.model';
import { ContainerComponent } from '../../container/container.component';
import { ButtonComponent } from '../button.component';

@Component({
    selector: 'sirius-button-group',
    // The container is what alignment acts on. Without it the host would shrink to fit its
    // buttons, leaving `justify-content` no free space to distribute - every alignment would
    // render identically, centred by the section.
    template: `
        <sirius-container>
            @for (button of buttons; track button.link?.href ?? $index; let i = $index) {
                <a
                    siriusButton
                    [siriusLink]="button.link"
                    [iconName]="button.iconName"
                    [buttonText]="button.link.title"
                    [buttonType]="i === 0 ? 'primary' : 'secondary'"
                ></a>
            }
        </sirius-container>
    `,
    styleUrls: ['./button-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, ContainerComponent, LinkDirective],
    host: {
        '[class.is-left]': "alignment === 'left'",
        '[class.is-center]': "alignment === 'center'",
        '[class.is-right]': "alignment === 'right'",
    },
})
export class ButtonGroupComponent implements OnInit, IDynamicElement {
    config?: IButtonGroup;

    @Input() buttons?: IButton[];
    @Input() direction: 'column' | 'row' = 'row';

    /**
     * The leading button carries the primary action and the rest read as alternatives, so the
     * type follows position rather than a per-button field. Two primaries side by side would
     * leave a reader with no principal action.
     */
    @Input() alignment: ButtonGroupAlignment = 'left';

    @HostBinding('class.sir-flex-column') get flexColumn(): boolean {
        return this.direction === 'column';
    }

    ngOnInit(): void {
        if (this.config) {
            this.buttons = this.config.buttons;
            this.direction = this.config.direction;
            this.alignment = this.config.alignment ?? 'left';
        }
    }
}
